import { AbstractSearchCriteria } from './abstract-search-criteria';

export class DispatchEntrySearchCriteria extends AbstractSearchCriteria {

    filterByScheduleTime: boolean;
}
